export enum SortByType {
  UPDATED_AT_DESCEND = 'UPDATED_AT_DESCEND',
  UPDATED_AT_ASCEND = 'UPDATED_AT_ASCEND',
  CREATED_AT_DESCEND = 'CREATED_AT_DESCEND',
  CREATED_AT_ASCEND = 'CREATED_AT_ASCEND',
}
